import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { css } from '@emotion/core'
import { useWindowSize } from 'react-use'
import { useTranslation } from 'react-i18next'
import { fetchReservationMarketSegment } from '@/apis/aipass'
import { SettingReservationTab } from '@/components/pages/setting/reservation/tab'
import { SettingMarketSegmentList } from '@/components/pages/setting/reservation/market-segment/_index/list'
import { MarketSegmentType } from '@/models/reservation-market-segment'
import { SettingsLayout } from '@/components/layouts/settings-layout'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { AccountContext } from '@/contexts/account'
import { isScreenReadOnlyForUi } from '@/libs/hotel-pms-permission'

export const SettingReservationMarketSegment: React.FC = () => {
  const { t } = useTranslation()
  const { permissions, permissionsLoaded, permissionsError } = useContext<any>(AccountContext)
  const isSettingsReadOnly = isScreenReadOnlyForUi(permissions, 'settings', permissionsLoaded, permissionsError)
  const history = useHistory()
  const location = useLocation()

  const [marketSegments, setMarketSegments] = useState<MarketSegmentType[]>([])
  useEffect(() => {
    fetchReservationMarketSegment().then(setMarketSegments)
  }, [])

  const windows = useWindowSize()
  return (
    <SettingsLayout loading={false}>
      <>
        <div css={settingHeaderContainerStyle}>
          <SettingReservationTab currentTab="marketSegment" />
        </div>
        <div
          css={settingListContainerStyle}
          style={{
            maxHeight: windows.height - 148,
          }}
        >
          <div css={editButtonWrapperStyle}>
            <Button
              buttonType={isSettingsReadOnly ? ButtonType.PrimaryDisabled : ButtonType.Secondary}
              isDisabled={isSettingsReadOnly}
              onClick={() => {
                if (isSettingsReadOnly) {
                  alert(t('HotelPms.Error.readOnly'))
                  return
                }
                history.push({ pathname: '/setting/reservation/market-segment/edit', search: location.search })
              }}
              width={75}
              height={32}
              fontSize={12}
            >
              {t('Edit')}
            </Button>
          </div>
          <SettingMarketSegmentList marketSegments={marketSegments} />
        </div>
      </>
    </SettingsLayout>
  )
}

const settingListContainerStyle = css({
  boxShadow: '0px 0px 6px #0000001A',
  borderRadius: '0 5px 5px 5px',
  background: '#FFF',
  position: 'relative',
})

const settingHeaderContainerStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
})

const editButtonWrapperStyle = css({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '24px 32px 34px',
})
